import { Language } from '../context/LanguageContext';

export interface CollectionItem {
    id: string;
    name: string;
    description: string;
    image: string;
}

interface CollectionItemTranslation {
    name: string;
    description: string;
}

export interface TourmalineCollectionItemsTranslations {
    [itemId: string]: CollectionItemTranslation;
}

const tourmalineCollectionItemsTranslations: Record<Language, TourmalineCollectionItemsTranslations> = {
    en: {
        "1": {
            name: "Lucky Star bracelet",
            description: "Pink tourmaline with special frequency, 18k white gold"
        },
        "2": {
            name: "Lucky Star bracelet",
            description: "Pink tourmaline with special frequency, 18k rose gold"
        },
        "3": {
            name: "Lucky Star bracelet",
            description: "Green tourmaline with special frequency, 18k yellow gold"
        },
        "4": {
            name: "Lucky Star Triplet bracelet",
            description: "Three pink tourmalines with special frequency, 18k rose gold"
        },
        "5": {
            name: "Lucky Star Spiral bracelet",
            description: "Pink tourmalines with special frequency, 18k rose gold"
        },
        "6": {
            name: "Lucky Star Spiral bracelet",
            description: "Pink and green tourmalines with special frequency, 18k yellow gold"
        },
        "7": {
            name: "Lucky Star bracelet",
            description: "Pink tourmalines with special frequency, 18k white gold"
        },
        "8": {
            name: "Lucky Star necklace",
            description: "Green tourmaline with special frequency, 18k white gold"
        },
        "9": {
            name: "Lucky Star necklace",
            description: "Pink tourmaline with special frequency, 18k white gold"
        },
        "10": {
            name: "Compass pendant",
            description: "Green tourmaline, 18k yellow gold"
        },
        "11": {
            name: "Compass pendant with diamonds",
            description: "Green tourmaline, Niveau Elevé special cut diamonds, 18k yellow gold"
        },
        "12": {
            name: "Compass pendant with diamonds",
            description: "Pink tourmaline, Niveau Elevé special cut diamonds, 18k yellow gold"
        },
        "13": {
            name: "One Of A Kind Tourmaline ring",
            description: "Green tourmaline, princess cut diamonds, 18k white gold"
        },
        "14": {
            name: "Element bracelet with five tourmalines",
            description: "Five pink tourmalines, Topaz, stainless steel"
        },
        "15": {
            name: "Element bracelet with five tourmalines",
            description: "Five pink and green tourmalines, Topaz, stainless steel"
        },
        "16": {
            name: "Lucky Star ring",
            description: "Pink and green tourmalines with special frequency, 18k yellow gold"
        }
    },
    de: {
        "1": {
            name: "Lucky Star Armband",
            description: "Pink Turmalin mit spezieller Frequenz, 750 Weißgold"
        },
        "2": {
            name: "Lucky Star Armband",
            description: "Pinker Turmalin mit spezieller Frequenz, 750 Roségold"
        },
        "3": {
            name: "Lucky Star Armband",
            description: "Grüner Turmalin mit spezieller Frequenz, 750 Gelbgold"
        },
        "4": {
            name: "Armband Lucky Star Triplet",
            description: "Drei pinke Turmaline mit spezieller Frequenz, 750 Roségold"
        },
        "5": {
            name: "Glücksstern Spiralarmband",
            description: "Pinke Turmaline mit spezieller Frequenz, 750 Roségold"
        },
        "6": {
            name: "Glücksstern Spiralarmband",
            description: "Pinke und grüne Turmaline mit spezieller Frequenz, 750 Gelbgold"
        },
        "7": {
            name: "Lucky Star-Armband",
            description: "Pink Turmaline mit spezieller Frequenz, 750 Weißgold"
        },
        "8": {
            name: "Lucky Star Halskette",
            description: "Grüner Turmalin mit spezieller Frequenz, 750 Weißgold"
        },
        "9": {
            name: "Lucky Star Halskette",
            description: "Pinker Turmalin mit spezieller Frequenz, 750 Weißgold"
        },
        "10": {
            name: "Kompass-Anhänger",
            description: "Grüner Turmalin, 750 Gelbgold"
        },
        "11": {
            name: "Kompass-Anhänger mit Diamanten",
            description: "Grüner Turmalin, Diamanten im Brillantschliff, 750 Gelbgold"
        },
        "12": {
            name: "Kompass-Anhänger mit Diamanten",
            description: "Pinker Turmalin, Diamanten im Brillantschliff, 750 Gelbgold"
        },
        "13": {
            name: "Turmalin-Solitär Ring",
            description: "Grüner Turmalin, Diamanten im Prinzesscut Schliff, 750 Weißgold"
        },
        "14": {
            name: "Magie-Band mit fünf Turmalinen",
            description: "Fünf pinke Turmaline, Topas, Edelstahl"
        },
        "15": {
            name: "Magie-Band mit fünf Turmalinen",
            description: "Fünf pinke und grüne Turmaline, Topas, Edelstahl"
        },
        "16": {
            name: "Ring Lucky Star",
            description: "Pinker und grüner Turmalin mit spezieller Frequenz, 750 Gelbgold"
        }
    },
    fr: {
        "1": {
            name: "Bracelet Étoile Chanceuse",
            description: "Tourmaline rose avec fréquence spéciale, or blanc 18 carats"
        },
        "2": {
            name: "Bracelet Étoile Chanceuse",
            description: "Tourmaline rose avec fréquence spéciale, or rose 18 carats"
        },
        "3": {
            name: "Bracelet Étoile Chanceuse",
            description: "Tourmaline verte avec fréquence spéciale, or jaune 18 carats"
        },
        "4": {
            name: "Bracelet Étoile Chanceuse Triplet",
            description: "Trois tourmalines roses avec fréquence spéciale, or rose 18 carats"
        },
        "5": {
            name: "Bracelet Spirale Étoile Chanceuse",
            description: "Tourmalines roses avec fréquence spéciale, or rose 18 carats"
        },
        "6": {
            name: "Bracelet Spirale Étoile Chanceuse",
            description: "Tourmalines roses et vertes avec fréquence spéciale, or jaune 18 carats"
        },
        "7": {
            name: "Bracelet Étoile Chanceuse",
            description: "Tourmalines roses avec fréquence spéciale, or blanc 18 carats"
        },
        "8": {
            name: "Collier Étoile Chanceuse",
            description: "Tourmaline verte avec fréquence spéciale, or blanc 18 carats"
        },
        "9": {
            name: "Collier Étoile Chanceuse",
            description: "Tourmaline rose avec fréquence spéciale, or blanc 18 carats"
        },
        "10": {
            name: "Pendentif Boussole",
            description: "Tourmaline verte, or jaune 18 carats"
        },
        "11": {
            name: "Pendentif Boussole avec diamants",
            description: "Tourmaline verte, diamants taille spéciale Niveau Élevé, or jaune 18 carats"
        },
        "12": {
            name: "Pendentif Boussole avec diamants",
            description: "Tourmaline rose, diamants taille spéciale Niveau Élevé, or jaune 18 carats"
        },
        "13": {
            name: "Bague Tourmaline Unique",
            description: "Tourmaline verte, diamants taille princesse, or blanc 18 carats"
        },
        "14": {
            name: "Bracelet Élément avec cinq tourmalines",
            description: "Cinq tourmalines roses, Topaze, acier inoxydable"
        },
        "15": {
            name: "Bracelet Élément avec cinq tourmalines",
            description: "Cinq tourmalines roses et vertes, Topaze, acier inoxydable"
        },
        "16": {
            name: "Bague Étoile Chanceuse",
            description: "Tourmalines roses et vertes avec fréquence spéciale, or jaune 18 carats"
        }
    },
    zh: {
        "1": {
            name: "幸运星手链",
            description: "粉色电气石，特殊频率，18K白金"
        },
        "2": {
            name: "幸运星手链",
            description: "粉色电气石，特殊频率，18K玫瑰金"
        },
        "3": {
            name: "幸运星手链",
            description: "绿色电气石，特殊频率，18K黄金"
        },
        "4": {
            name: "幸运星三重手链",
            description: "三颗粉色电气石，特殊频率，18K玫瑰金"
        },
        "5": {
            name: "幸运星螺旋手链",
            description: "粉色电气石，特殊频率，18K玫瑰金"
        },
        "6": {
            name: "幸运星螺旋手链",
            description: "粉色和绿色电气石，特殊频率，18K黄金"
        },
        "7": {
            name: "幸运星手链",
            description: "粉色电气石，特殊频率，18K白金"
        },
        "8": {
            name: "幸运星项链",
            description: "绿色电气石，特殊频率，18K白金"
        },
        "9": {
            name: "幸运星项链",
            description: "粉色电气石，特殊频率，18K白金"
        },
        "10": {
            name: "指南针吊坠",
            description: "绿色电气石，18K黄金"
        },
        "11": {
            name: "镶钻指南针吊坠",
            description: "绿色电气石，Niveau Elevé特殊切割钻石，18K黄金"
        },
        "12": {
            name: "镶钻指南针吊坠",
            description: "粉色电气石，Niveau Elevé特殊切割钻石，18K黄金"
        },
        "13": {
            name: "独特电气石戒指",
            description: "绿色电气石，公主方钻，18K白金"
        },
        "14": {
            name: "五电气石元素手链",
            description: "五颗粉色电气石，黄玉，不锈钢"
        },
        "15": {
            name: "五电气石元素手链",
            description: "五颗粉色和绿色电气石，黄玉，不锈钢"
        },
        "16": {
            name: "幸运星戒指",
            description: "粉色和绿色电气石，特殊频率，18K黄金"
        }
    }
};

export function getTourmalineCollectionItems(language: Language): CollectionItem[] {
    const translations = tourmalineCollectionItemsTranslations[language] || tourmalineCollectionItemsTranslations.en;

    return Object.keys(translations).map(id => ({
        id,
        name: translations[id].name,
        description: translations[id].description,
        image: `/images/jewellery_tourmaline_grid_${id === "16" ? "" : id + "_"}${id === "1" || id === "2" || id === "3" || id === "4" || id === "5" || id === "6" || id === "7"
            ? "bracelet" + (id === "1" ? "1" : id === "2" ? "2" : id === "3" ? "3" : id === "4" ? "4" : id === "5" ? "5" : id === "6" ? "6" : "7")
            : id === "8" || id === "9"
                ? "necklace" + (id === "8" ? "1" : "2")
                : id === "10" || id === "11" || id === "12"
                    ? "pendant" + (id === "10" ? "1" : id === "11" ? "2" : "3")
                    : id === "13"
                        ? "ring2"
                        : id === "14" || id === "15"
                            ? "topazbracelet" + (id === "14" ? "2" : "3")
                            : "ring1"
            }.png`
    }));
} 